import ChatWidget from "./chatWidget";


const PublicBot = () => {
    return (
        <>
               <style>
                {`
                .iframe-container {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border: none;
                    z-index: -1; /* Push behind everything */
                }
                
                `}
            </style>
            <iframe className="iframe-container" src="https://optiorx.com"></iframe>
            
            <ChatWidget/>
        </>
    )
}

export default PublicBot;